<template>
	<div class="mypage">
		<div class="mypage-intro u-container">
			<div>
				<div class="mypage-intro__button">
					<Btn v-if="isRegularUser" color="primary" small>정회원</Btn>
					<Btn v-else @click="onClickUpdateToRegular" color="primary" small
						>정회원 전환</Btn
					>
				</div>
				<div class="mypage-intro__greeting">
					<span class="user-name">
						<span class="user-name__name">{{ userName }}</span> </span
					>님의<br />
					하이모 이용 정보
				</div>
			</div>
			<div class="mypage-intro__privacy-button">
				<Btn color="secondary" @click="openModal('ModalPrivacy')"
					>개인정보 처리 방침</Btn
				>
			</div>
		</div>

		<div class="mypage-main u-container">
			<div class="mypage-card-container">
				<section class="mypage-card">
					<div class="mypage-card__content">
						<h2 class="card-title">회원 등급</h2>

						<div class="card-main-box">
							<div class="columns flex-centered">
								<div class="column col-auto">
									<!-- 회원 등급 아이콘 -->
									<div class="card-deco">
										<div
											:style="'background-image: url(' + mbsClassIcon + ');'"
											:class="[
												'membership-icon',
												{ 'membership-icon--empty': !isRegularUser },
											]"
										></div>
									</div>
								</div>
								<div class="column col-auto">
									<!-- 정회원일 경우 멤버쉽 등급 명칭 불러오기 -->
									<div
										v-if="isRegularUser"
										:class="mbsClassColor"
										class="card-main-font"
									>
										<span class="card-main-font__main">{{ mbsClass }}</span>
									</div>
									<!-- 아닐 경우 준회원으로 -->
									<div v-else class="card-main-font">
										<span class="card-main-font__main">준회원</span>
									</div>
								</div>
							</div>
						</div>

						<div class="card-button">
							<a
								@click="openModal('ModalMembership')"
								class="card-button__btn"
								href="javascript:;"
							>
								회원 등급 안내
								<i class="ri-arrow-drop-right-line"></i>
							</a>
						</div>
					</div>
				</section>

				<section class="mypage-card">
					<div class="mypage-card__content">
						<h2 class="card-title">마일리지</h2>

						<div class="card-main-box">
							<div v-if="isRegularUser" class="columns flex-centered">
								<div class="column col-auto">
									<div class="card-deco">
										<div
											:style="
												'background: url(' +
												icoCoin +
												') no-repeat 0 0 / contain;'
											"
											class="mileage-icon"
										></div>
									</div>
								</div>
								<div class="column col-auto">
									<div class="card-main-font card-main-font--yellow">
										<span class="card-main-font__main">{{ useMileage }}</span>
										<span class="card-main-font__unit">마일</span>
										<span class="card-main-font__text">보유</span>
									</div>
								</div>
								<div class="column col-12">
									<div class="card-detail">소멸 예정 : {{ extinAmt }} 마일</div>
								</div>
							</div>
							<div v-else class="card-detail">
								마일리지는 <strong>정회원 등급 부터</strong><br />
								확인 가능합니다.
							</div>
						</div>

						<div v-if="isRegularUser" class="card-button">
							<a
								@click="$router.push({ name: 'mileage' })"
								class="card-button__btn"
								href="javascript:;"
							>
								마일리지 내역 확인
								<i class="ri-arrow-drop-right-line"></i>
							</a>
						</div>
						<div v-else class="card-button">
							<a
								@click="openModal('ModalUserLevel')"
								class="card-button__btn"
								href="javascript:;"
							>
								자세히 보기
								<i class="ri-arrow-drop-right-line"></i>
							</a>
						</div>
					</div>
				</section>

				<section class="mypage-card">
					<div class="mypage-card__content">
						<h2 class="card-title">최근 방문 내역</h2>

						<div v-if="isRegularUser" class="card-detail">
							<dl>
								<dt>지점</dt>
								<dd>{{ lastVisitSaupjangNm }}</dd>
								<dt>날짜</dt>
								<dd>{{ lastVisitDt }}</dd>
							</dl>
						</div>
						<div v-else class="card-detail">
							방문 지점은 <strong>정회원 등급 부터</strong><br />
							확인 가능합니다.
						</div>

						<div v-if="isRegularUser" class="card-button">
							<a
								@click="$router.push({ name: 'reservation' })"
								class="card-button__btn card-button__btn--half"
								href="javascript:;"
							>
								지점 예약 내역
								<i class="ri-arrow-drop-right-line"></i>
							</a>
							<a
								@click="$router.push({ name: 'reservationWaiting' })"
								class="card-button__btn card-button__btn--half"
								href="javascript:;"
							>
								지점 대기 내역
								<i class="ri-arrow-drop-right-line"></i>
							</a>
						</div>
						<div v-else class="card-button">
							<a
								@click="openModal('ModalUserLevel')"
								class="card-button__btn card-button__btn--half"
								href="javascript:;"
							>
								자세히 보기
								<i class="ri-arrow-drop-right-line"></i>
							</a>
						</div>
					</div>
				</section>

				<section class="mypage-card is-slim">
					<router-link :to="{ name: 'contract' }">
						<div class="mypage-card__content">
							<h2 class="card-title">계약 내역</h2>
							<div class="arrow-right-box">
								<i class="ri-arrow-right-s-line"></i>
							</div>
						</div>
					</router-link>
				</section>

				<section class="mypage-card is-slim">
					<router-link :to="{ name: 'asStamp' }">
						<div class="mypage-card__content">
							<h2 class="card-title">My 관리서비스 현황</h2>
							<div class="arrow-right-box">
								<i class="ri-arrow-right-s-line"></i>
							</div>
						</div>
					</router-link>
				</section>

				<section class="mypage-card is-slim">
					<router-link :to="{ name: 'coupon' }">
						<div class="mypage-card__content">
							<h2 class="card-title">My 쿠폰함</h2>
							<div class="arrow-right-box">
								<i class="ri-arrow-right-s-line"></i>
							</div>
						</div>
					</router-link>
				</section>

				<section class="mypage-card is-slim">
					<router-link :to="{ name: 'inquiry' }">
						<div class="mypage-card__content">
							<h2 class="card-title">1:1 문의</h2>
							<div class="arrow-right-box">
								<i class="ri-arrow-right-s-line"></i>
							</div>
						</div>
					</router-link>
				</section>
			</div>

			<div class="button-box">
				<div class="form-group form-button">
					<Btn
						@click="$router.push({ name: 'editUser' })"
						color="primary"
						x-large
						block
						>회원 정보 수정
					</Btn>
				</div>
				<div class="form-group form-button">
					<Btn @click="onClickLogout" color="secondary" x-medium block
						>로그아웃
					</Btn>
				</div>
			</div>
		</div>

		<component v-if="modalComp" :is="modalComp" />
	</div>
</template>

<script>
import mixin from '@/mixins/mixin';

import icoGradeGreen from '@/assets/images/common/ico-grade-green.svg';
import icoGradeBlue from '@/assets/images/common/ico-grade-blue.svg';
import icoGradeRed from '@/assets/images/common/ico-grade-red.svg';
import icoGradePurple from '@/assets/images/common/ico-grade-purple.svg';
import icoGradeBlack from '@/assets/images/common/ico-grade-black.svg';

import icoCoin from '@/assets/images/common/ico-coin.svg';

import { sendToID } from '@/utils/interface';
import { updateToRegularUserLevel, fetchMileage } from '@/api';

import { numberWithCommas } from '@/utils/util';

import Btn from '@/components/common/Btn';

export default {
	mixins: [mixin],
	components: {
		Btn,
	},
	data() {
		return {
			mileage: {},
			membershipShow: false,
			useMileage: 0,
			extinAmt: 0,
			modalComp: null,
		};
	},
	computed: {
		user() {
			return this.$store.state.userStore.user;
		},
		userId() {
			return this.$store.state.userStore.user.user_id;
		},
		userName() {
			return this.$store.state.userStore.user.user_name;
		},
		isRegularUser() {
			return this.$store.getters['userStore/isRegularUser'];
		},
		mbsClassIcon() {
			let ret = '';

			switch (this.mbsClass) {
				case 'GREEN':
					ret = icoGradeGreen;
					break;
				case 'BLUE':
					ret = icoGradeBlue;
					break;
				case 'RED':
					ret = icoGradeRed;
					break;
				case 'PURPLE':
					ret = icoGradePurple;
					break;
				case 'BLACK':
					ret = icoGradeBlack;
					break;
				default:
					ret = icoGradeGreen;
					break;
			}

			return ret;
		},
		mbsClassColor() {
			let ret = '';

			switch (this.mbsClass) {
				case 'GREEN':
					ret = 'card-main-font--green';
					break;
				case 'BLUE':
					ret = 'card-main-font--blue';
					break;
				case 'RED':
					ret = 'card-main-font--red';
					break;
				case 'PURPLE':
					ret = 'card-main-font--purple';
					break;
				case 'BLACK':
					ret = 'card-main-font--black';
					break;
				default:
					ret = '';
					break;
			}

			return ret;
		},
		// 마일리지 아이콘
		icoCoin() {
			return icoCoin;
		},
		// 멤버쉽 등급 (GREEN, BLUE ...)
		mbsClass() {
			let mbsClass = this.mileage.MBS_CLASS;
			if (!mbsClass) mbsClass = '-';

			return mbsClass;
		},
		// 최근 방문 지점
		lastVisitSaupjangNm() {
			let lastVisitSaupjangNm = this.mileage.LAST_VISIT_SAUPJANG_NM;
			if (!lastVisitSaupjangNm) lastVisitSaupjangNm = '-';

			return lastVisitSaupjangNm;
		},
		// 최근 방문 날짜
		lastVisitDt() {
			let lastVisitDt = '-　　　';
			if (this.mileage.LAST_VISIT_DT) {
				const date = '' + this.mileage.LAST_VISIT_DT;
				lastVisitDt = `${date.substr(0, 4)}.${date.substr(4, 2)}.${date.substr(
					6,
					2,
				)}`;
			}

			return lastVisitDt;
		},
	},
	methods: {
		init() {
			this.renderMileage();
		},
		async onClickUpdateToRegular() {
			const params = {
				userId: this.user.user_id,
				userName: this.user.user_name,
				userHp: this.user.user_hp,
			};

			const { data } = await updateToRegularUserLevel(params);

			const message = data.message;
			const options = {
				okLabel: '확인',
				message,
			};
			this.showAlert(options);

			if (data.code === '00000' && data.user_level) {
				this.$store.commit('userStore/setUserLevel', data.user_level);
			}
		},
		openModal(compName) {
			if (!compName) return;

			this.modalComp = async () =>
				(await import(`@/components/${compName}.vue`)).default;
		},
		async renderMileage() {
			const params = {
				userId: this.userId,
			};

			const { data } = await fetchMileage(params);

			if (data.code === '00000') {
				this.mileage = data.mileage;

				if (this.mileage.USE_MILEAGE) {
					this.useMileage = numberWithCommas(this.mileage.USE_MILEAGE); // 사용 가능 마일리지
				}
				if (this.mileage.EXTIN_AMT) {
					this.extinAmt = numberWithCommas(this.mileage.EXTIN_AMT); // 소멸 예정 마일리지
				}
			}
		},
		onClickLogout() {
			// app으로 빈 아이디값 전달
			sendToID('');

			this.$store.dispatch('userStore/userLogout');
			this.$router.push({ name: 'login' });
		},
	},
	created() {
		this.init();
	},
};
</script>

<style scoped>
.mypage-intro {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 1.25rem 0;
	background: #ededed;
}

.mypage-intro__privacy-button {
	flex: 0 0 160px;
	text-align: right;
}

.mypage-intro__greeting {
	margin-top: 0.625rem;
	font-family: 'Gmarket Sans', sans-serif;
	font-size: 1rem;
	font-weight: 500;
}

.user-name {
	font-size: 1rem;
	font-weight: 700;
	line-height: 1.25;
}

.user-name__name {
	font-size: 1.71875rem;
}

.mypage-main {
	padding: 1rem 0;
}

.mypage-card-container {
	display: flex;
	flex-flow: row wrap;
	margin: -0.25rem;
}

.mypage-card {
	flex: 0 0 100%;
	padding: 0.25rem;
	text-align: center;
}

.mypage-card--width-half {
	flex: 0 0 50%;
}

.mypage-card__content {
	display: flex;
	flex-flow: column wrap;
	justify-content: space-between;
	height: 100%;
	min-height: 8.75rem;
	padding: 0.75rem 0.625rem;
	border-radius: 3px;
	border: 1px solid #c8c8c8;
}

.mypage-card.is-slim .mypage-card__content {
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
	min-height: auto;
	padding: 1rem 1.375rem;
}

.card-deco {
	display: flex;
	align-items: flex-start;
	height: 100%;
}

.membership-icon {
	width: 24px;
	height: 20px;
	background-repeat: no-repeat;
	background-position: 0 0;
	-webkit-background-size: contain;
	background-size: contain;
}

.membership-icon--empty {
	filter: grayscale(100%);
}

.mileage-icon {
	width: 35px;
	height: 35px;
}

.card-title {
	position: relative;
	display: table;
	padding: 0 0.375rem;
	margin: 0 auto 0.75rem;
	color: #222;
	font-size: 0.875rem;
	font-weight: 500;
	line-height: 1;
}

.mypage-card.is-slim .card-title {
	margin: 0;
}

.card-title::after {
	content: '';
	position: absolute;
	z-index: -1;
	left: 0;
	right: 0;
	bottom: -0.1875rem;
	height: 0.375rem;
	background: #ededed;
}

.arrow-right-box {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 16px;
	height: 16px;
	border: 1px solid #c8c8c8;
	background: #222;
	color: #c8c8c8;
	font-size: 0.75rem;
}

.card-main-font {
	padding-top: 0.25rem;
	color: #222;
	font-family: 'Gmarket Sans', sans-serif;
	line-height: 1;
}

.card-main-font--green {
	color: #2cb79c;
}

.card-main-font--blue {
	color: #75b2e0;
}

.card-main-font--red {
	color: #e03f3f;
}

.card-main-font--purple {
	color: #5c3bff;
}

.card-main-font--black {
	color: #404040;
}

.card-main-font--yellow {
	color: #ffa21e;
}

.card-main-font__main {
	font-size: 1.25rem;
	font-weight: 700;
}

.card-main-font__unit {
	font-size: 0.9375rem;
	font-weight: 500;
}

.card-main-font__text {
	font-size: 0.75rem;
	font-weight: 300;
}

.card-button {
	display: flex;
	flex-flow: row wrap;
	margin-top: 0.75rem;
	justify-content: center;
}

.card-button__btn {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	max-width: 140px;
	height: 1.5rem;
	padding: 0 0.5rem;
	margin: 0 0.2rem;
	border: 1px solid #c8c8c8;
	background: #222;
	color: #fff;
	font-size: 0.75rem;
	font-weight: 300;
}

.card-button__btn--half {
	width: calc(50% - 0.625rem - 0.25rem - 1px);
}

.card-button__btn i {
	font-size: 1rem;
}

.card-detail {
	margin-top: 0.25rem;
	color: #999;
	font-size: 0.8125rem;
}

.card-detail strong {
	font-weight: 500;
}

.card-detail dl {
	display: flex;
	flex-flow: row wrap;
	max-width: 140px;
	margin: 0 auto;
	padding: 0 0.5rem;
}

.card-detail dt,
.card-detail dd {
	font-size: 0.875rem;
	text-align: left;
}

.card-detail dt {
	flex: 0 0 40%;
	color: #666;
	font-weight: 300;
}

.card-detail dd {
	flex: 0 0 60%;
	color: #222;
	font-weight: 500;
}

.button-box {
	width: 80%;
	margin: 1.25rem auto 0;
}
</style>
